import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { TranslateService } from '@ngx-translate/core';

import { NumberFormatterService } from '../services/number/number-formatter.service';
import { LocaleService } from '../services/locale/locale.service';

import { SymbolType } from '../domain/symbol.domain';
import { BaseNumberPipe } from './base-number.pipe';

export interface QuantityPipeParameters {
  symbolType: SymbolType | string;
}

@Pipe({
  name: 'tdWbQuantity'
})
export class QuantityPipe extends BaseNumberPipe implements PipeTransform {
  private decimalPipe: DecimalPipe;

  constructor(translateService: TranslateService, localeService: LocaleService) {
    super(translateService);
    this.decimalPipe = new DecimalPipe(localeService.getLocale());
  }

  transform(value: number | undefined | null, pipeParameters: QuantityPipeParameters): string {
    const format: string = pipeParameters.symbolType === SymbolType.MUTUALFUND ? 'n3-0' : 'n5-0';
    return this.renderValue(value, { format });
  }

  protected doFormat(val: number, format: string, precision: number): string {
    const adjustedPrecision: number = NumberFormatterService.getAdjustedPrecision(val, format, precision);
    return this.decimalPipe.transform(val, NumberFormatterService.getPrecisionString(adjustedPrecision));
  }
}

